
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
/**
    OverviewData, // 总览数据
    CoreData, // 核心数据
    CategoryProportion, // 类别占比
    PaymentMethod, // 付款方式
    GoodsRanking, //商品排行
    CashReconciliation, //收银对账
    TransactionDetails, // 交易明细
    MemberAnalysis, // 会员分析
 */

@Component({
  name: "SkeletonCard",
})
export default class SkeletonCard extends Vue {
  @Prop({ default: () => {} }) showList!: string[]; // ['总览数据','核心数据',...]
  @Prop({ default: true }) showHeader: boolean; // 是否显示头部文字
}
